import { connect } from 'react-redux';

import { ArchiveClientModalContent } from './ArchiveClientModalContent';
import { createArchiveClient } from 'api/clients/clients.actions';
import { fetchEvents } from 'api/events/events.actions';

const mapDispatchToProps = (dispatch: Function) => ({
  archiveClient: (clientId: string, archived: boolean) => {
    return dispatch(createArchiveClient({ id: clientId, archived: !archived }));
  },
  getEvents: () => {
    return dispatch(fetchEvents());
  },
  getArchivedEvents: () => {
    return dispatch(fetchEvents(true));
  },
});

export const ArchiveClientModalContentContainer = connect(null, mapDispatchToProps)(ArchiveClientModalContent);
